export default __webpack_public_path__ + "static/media/cert_cad.f8ab072a.png";